import tinycolor from '@ctrl/tinycolor';

export const setColorAlpha = (color: string, newAlpha: number) => {
  return tinycolor(color).setAlpha(newAlpha).toRgbString();
};

export const getColorAlpha = (color: string) => {
  return tinycolor(color).getAlpha();
};
